import React from "react";
import { FiXCircle } from "react-icons/fi";

function PopupModalSmall({ onCloseBtnPress, children }) {
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="inset-0 flex items-center justify-center bg-gray-800 bg-opacity-20 absolute">
                <div
                    className="rounded p-2 bg-white"
                    style={{
                        overflowY: "auto",
                        overflowX: "auto",
                    }}
                >
                    <div className="flex items-center justify-between grow">
                        <h3 className="text-xxl font-bold uppercase text-black ml-5 mt-5 pl-20"></h3>
                        <div className="cursor-pointer">
                            <FiXCircle onClick={onCloseBtnPress} />
                        </div>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default PopupModalSmall;
